import TitleBlock from '@anm/components/TitleBlock';
import styled, { css } from 'styled-components';

export const sectionTitleCSS = css`
  margin-bottom: 14px;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 18px;
    line-height: 24px;
  }
`;

const SectionTitle = styled(TitleBlock)`
  ${sectionTitleCSS};
`;

export default SectionTitle;
